/** @jsxImportSource @emotion/react */
import React from 'react'
import { css } from '@emotion/react'
import colors from '@sportninja/common/constants/appColors'
import { COLUMN_WIDTHS } from './types'

/**
 * Table header row for time slots
 * Matches Figma design with column labels
 */
const TimeSlotTableHeader: React.FC = () => {
  const headerCellStyles = css`
    font-family: 'Inter', sans-serif;
    font-size: 12px;
    font-weight: 500;
    line-height: 17.4px;
    color: ${colors.NEUTRAL_70};
    text-transform: uppercase;
  `

  return (
    <div
      css={css`
        display: flex;
        align-items: center;
        gap: 16px;
        padding: 4px 16px 4px 48px;
        background-color: ${colors.SECONDARY_400};
        width: 100%;
      `}
    >
      <span
        css={css`
          ${headerCellStyles}
          width: ${COLUMN_WIDTHS.SLOT}px;
        `}
      >
        SLOT
      </span>
      <span
        css={css`
          ${headerCellStyles}
          width: ${COLUMN_WIDTHS.FREQUENCY}px;
        `}
      >
        FREQUENCY
      </span>
      <span
        css={css`
          ${headerCellStyles}
          width: ${COLUMN_WIDTHS.DATE}px;
        `}
      >
        DATE
      </span>
      <span
        css={css`
          ${headerCellStyles}
          width: ${COLUMN_WIDTHS.DAYS}px;
        `}
      >
        DAYS OF WEEK
      </span>
      <span
        css={css`
          ${headerCellStyles}
          width: ${COLUMN_WIDTHS.START_TIME}px;
        `}
      >
        START TIME
      </span>
      <span
        css={css`
          ${headerCellStyles}
          width: ${COLUMN_WIDTHS.END_TIME}px;
        `}
      >
        END TIME
      </span>
      <span
        css={css`
          ${headerCellStyles}
          width: ${COLUMN_WIDTHS.DURATION}px;
        `}
      >
        DURATION
      </span>
      <span
        css={css`
          ${headerCellStyles}
          width: ${COLUMN_WIDTHS.DIVISIONS}px;
        `}
      >
        DIVISIONS
      </span>
      {/* Actions column - hidden header */}
      <span
        css={css`
          ${headerCellStyles}
          width: ${COLUMN_WIDTHS.ACTIONS}px;
          opacity: 0;
        `}
      >
        ACTIONS
      </span>
    </div>
  )
}

export default TimeSlotTableHeader
